import { render, staticRenderFns } from "./Ecuador.vue?vue&type=template&id=5f438924&scoped=true&"
import script from "./Ecuador.vue?vue&type=script&lang=js&"
export * from "./Ecuador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f438924",
  null
  
)

export default component.exports